<template>
  <div class="report_detailed">
    <headerSection />

    <div class="container py-4 report_detailed_inner">
      <!-- Title -->
      <div class="">
        <div class="mb-3 p-2 px-4 bg-white">
          <p class="text-blue-main-toeic text-left mb-1 font-semibold m-0">2025/08/08</p>
          <h3 class="text-center font-bold">多益口說練習 第一回　詳解</h3>
        </div>
        <div class="row mx-0 mb-2">
          <!-- Left Info -->
          <div class="col-md-4 text-center">
            <report_menu :reportData="reportData" @emitSelectedIndex="emitSelectedIndex" />
          </div>

          <!-- Right Score -->
          <div class="col-md-8 text-center text-left px-0">
            <div class="p-2 px-4 d-flex align-items-center bg-white mb-2" v-if="returnReportData?.user_answer?.audio">
              <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap font-semibold">我的錄音</p>
              <audio controls :src="returnReportData.user_answer.audio" class="w-100 bg-white toeic-audio"></audio>
            </div>
            <!-- 發音語調重音 -->
            <div class="p-2 px-4 bg-white mb-2">
              <div class="d-flex align-items-center justify-content-between">
                <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap font-semibold">發音語調重音</p>
                <a class="d-inline-block m-1 mx-2 pointer" style="max-width: 120px;" @click="showExplanation">
                  <img src="@/assets/image/toeic/toeic_exam/btn_analysis.png" alt="" class="object-contain w-100">
                </a>
              </div>
              <div class="text-left">
                <p class="m-0 font-semibold">發音 (Pronunciation)：<span class="text-orange-main-toeic">{{ pronScore }}</span></p>
                <p>朗讀時，發音非常容易可以理解。</p>

                <p class="m-0 font-semibold">語調重音 (Intonation & Stress)：<span class="text-orange-main-toeic">{{ pronScore }}</span></p>
                <p>朗讀時，語調與重音的使用非常適當。</p>
              </div>
            </div>
            <!-- AI批改結果 -->
            <div class="p-2 px-4 bg-white mb-2" v-if="returnReportData?.result?.ers">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap font-semibold">AI批改結果</p>
                <p class="m-0 text-xs"><span class="mr-2 text-green-main-toeic">●唸得很好</span><span class="mr-2 text-yellow-main-toeic">●需要加強</span><span class="mr-2 text-red-main-toeic">●唸得不清楚</span></p>
              </div>
              <p class="font-semibold gept_main_color p-2 text-left" v-html="correctResult"></p>
                <!-- <span v-for="(child, idx) in spiltWords(returnReportData.result.ers.Text)" :key="idx"
                :class="{ 'text-green-main-toeic': checkScore(returnReportData.result.ers.WordScores, returnReportData.result.ers.Text, child) > 80,
                'text-yellow-main-toeic': checkScore(returnReportData.result.ers.WordScores, returnReportData.result.ers.Text, child) > 60 && checkScore(returnReportData.result.ers.WordScores, returnReportData.result.ers.Text, child) < 81,
                'text-red-main-toeic': checkScore(returnReportData.result.ers.WordScores, returnReportData.result.ers.Text, child) < 61 }">
                {{ child }}</span> -->
            </div>
            <!-- 題目與解析 -->
            <div class="p-2 px-4 bg-white mb-2" v-if="questionAnalysis">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex">
                  <span class="d-block mr-2" @click="isShowAnalysis = !isShowAnalysis">
                    <i class="fas fa-chevron-up"></i>
                    <!-- <i class="fas fa-chevron-down" v-else></i> -->
                  </span>
                  <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap font-semibold">題目與解析</p>
                </div>
                <a class="d-inline-block m-1 mx-2 pointer" style="max-width: 120px;" @click="showQuestion">
                  <img src="@/assets/image/toeic/toeic_exam/btn_check_subject.png" alt="" class="object-contain w-100">
                </a>
              </div>
              <!-- 參考答案 -->
              <div v-if="isShowAnalysis && returnReportData?.result">
                <div class="d-flex align-items-center bg-white mb-2" >
                  <p class="text-blue-main-toeic text-left m-0 mr-2 whitespace-nowrap">參考答案</p>
                  <audio controls :src="returnReportData.result.question.AudioUrl" class="w-100"></audio>
                </div>
                <div class="text-left mb-3" v-html="returnReportData.result.question.Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></div>
                <div class="text-left mb-3" v-html="returnReportData.result.question.Guide.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></div>
                <div class="text-left mb-3" v-html="returnReportData.result.question.Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></div>
              </div>
            </div>
            <!-- <div class="p-3 bg-gray-toeic">
              <p class="max-w-xl mx-auto text-left m-0 text-lg">Directions: In this part of the test, you will read aloud the text on the screen. You will have 45 seconds to prepare. Then you will have 45 seconds to read the text aloud.</p>
            </div>
            <div class="p-3 mb-5">
              <p class="max-w-xl mx-auto text-left m-0 text-lg">Good evening, this is the National Weather Bureau’s report for Friday, October 15th. An arctic air mass originating from northern Canada is advancing southward, accompanied by gusty winds and torrential rainfall. Meteorologists anticipate that temperatures in metropolitan Chicago will plummet to approximately 42 degrees Fahrenheit overnight. Skies will gradually clear by Saturday morning, though the daytime high is projected to peak at a mere 55 degrees. Authorities urge residents across the Great Lakes corridor to brace for potential infrastructural disruptions and hazardous driving conditions. Meanwhile, coastal urban centers such as Boston and New York City will experience intermittent showers through the duration of the weekend. The frontal system is expected to dissipate by late Sunday afternoon, restoring fair weather. Thank you for listening—please remain vigilant and consult local updates for further advisories.</p>
            </div> -->
            <!-- <div class="d-flex justify-content-center align-content-center max-w-lg mx-auto w-100">
              <a class="d-inline-block m-1 mx-2 pointer">
                <img src="@/assets/image/toeic/toeic_exam/btn_myVoice.png" alt="" class="object-contain w-100">
              </a>
              <a class="d-inline-block m-1 mx-2 pointer" @click="answer_analysis">
                <img src="@/assets/image/toeic/toeic_exam/btn_questionAnalysis.png" alt="" class="object-contain w-100">
              </a>
              <a class="d-inline-block m-1 mx-2 pointer" @click="question_Analysis">
                <img src="@/assets/image/toeic/toeic_exam/btn_AnswerAnalysis.png" alt="" class="object-contain w-100">
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
  import { mapActions, mapGetters } from 'vuex'
  import headerSection from '@/components/AiHelper/toeic/headerSection'
  import report_menu from '@/components/AiHelper/toeic/report_menu'
  import radarChart from '@/components/AiHelper/toeic/radarChart'
  import api from '@/store/api'
  export default {
    name: 'report_detailed',
    components: {
      headerSection,
      report_menu
    },
    data () {
      return {
        reportData: null,
        questionAnalysis: null,
        selectedIndex: 0,
        selectedIndex2: 0,
        isShowAnalysis: true
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters([
        'remainPoints'
      ]),
      returnReportData () {
        if (this.reportData) {
          return this.reportData.part[this.selectedIndex].data[this.selectedIndex2]
        }
        return null
      },
      pronScore () {
        let PronScore = this.returnReportData.result.ers.Scores.PronScore
        if (PronScore > 80) return '高(High)'
        if (PronScore>= 70 && PronScore < 80) return '中(Medium)'
        if (PronScore < 70) return '低(Low)'
        return 'LOW'
      },
      ProsodyScore () {
        let PronScore = this.returnReportData.result.ers.Scores.PronScore
        if (PronScore > 80) return '高(High)'
        if (PronScore>= 70 && PronScore < 80) return '中(Medium)'
        if (PronScore < 70) return '低(Low)'
        return 'LOW'
      },
      correctResult () {
        if (!this.returnReportData) return []

        const ersMap = new Map(
          this.returnReportData.result.ers.Words.map(item => [item.Word.toLowerCase(), item.ErrorType])
        )

        const originalText = this.returnReportData.result.ers.Text || ''

        const wordsInOriginal = originalText.match(/[\w’']+|[.,!?;]/g) || []

        const htmlWords = wordsInOriginal.map(word => {
          const cleanWord = word.toLowerCase()
          const errorType = ersMap.get(cleanWord)
          let color = ''

          if (errorType !== undefined) {
            if (errorType === 'None') color = 'green'
            else if (errorType === 'Mispronunciation' || errorType === 'Monotone') color = 'orange'
            else if (errorType === 'Omission') color = 'red'
            else return ''

            return `<span style="color: ${color}; font-weight: bold;">${word}</span>`
          }
        }).join(' ')

        return htmlWords
      }
    },
    mounted() {
      this.getData()
      this.getQuestionAnalysisData()
    },
    methods: {
      ...mapActions({
        doGetPoints: 'getRemainPoints'
      }),
      answer_analysis () {
        this.$swal({
          html: `<p class="font-bold text-left">整體發音練習建議</p><p class="text-left">先慢唸整段，注意正確連音與停頓，尤其是句子之間的自然斷句
專有名詞如「Blue Valley Inn」「Lake Mead」需清晰、正確唸出
關鍵片語 （avoid vacation stress、personal attention、greatest treasure）可稍作停頓或強調，突顯語意
複合句（如 While staying at our inn.）語調應自然滑順，不要斷裂
形容詞串列 （spacious rooms, swimming pool and many outdoor activities）語調要有節奏感，避免平淡
廣告語氣應溫和、有吸引力，尤其是最後一句標語 “A happy guest is our greatest treasure."，可略帶微笑語氣朗讀，展現誠意與熱情</p>`,
          showConfirmButton: false,
          showCloseButton: true,
          focusConfirm: false,
          confirmButtonText: `我知道了`,
          title: '題目解析',
          customClass: {
            title: 'text-white bg-blue-lighter-toeic text-2xl pb-3',
            container: '',
            popup: 'p-0 max-w-3xl w-100',
            header: 'position-relative',
            closeButton: 'closeButton position-absolute',
            htmlContainer: 'my-3',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            cancelButton: 'bg-red-main-ai',
          }
        })
      },
      question_Analysis () {
        this.$swal({
          html: `
            <div class="text-left">
              <p class="text-black">發音清楚、語調自然，雖然有些單字略不清楚，但整體語意傳達完整。朗讀能掌握適當停頓與句子斷句，表現流暢。若能再加強部分片語（如 “spectacular sights”）的清晰度，並加入更多語氣變化，會更具吸引力。</p>
              <div class="row my-4">
                <div class="col-3 bg-blue-100 p-2 text-center">
                  <div class="border">
                    <div class="font-bold bg-blue-lighter-toeic text-white p-2 text-base">Accuracy<br>準確度</div>
                    <div class="text-2xl font-bold bg-gray-toeic2 p-3 text-black">60</div>
                  </div>
                </div>
                <div class="col-3 bg-blue-100 p-2 text-center">
                  <div class="border">
                    <div class="font-bold bg-blue-lighter-toeic text-white p-2 text-base">Fluency<br>流暢度</div>
                    <div class="text-2xl font-bold bg-gray-toeic2 p-3 text-black">80</div>
                  </div>
                </div>
                <div class="col-3 bg-blue-100 p-2 text-center">
                  <div class="border">
                    <div class="font-bold bg-blue-lighter-toeic text-white p-2 text-base">Completeness<br>完整度</div>
                    <div class="text-2xl font-bold bg-gray-toeic2 p-3 text-black">50</div>
                  </div>
                </div>
                <div class="col-3 bg-blue-100 p-2 text-center">
                  <div class="border">
                    <div class="font-bold bg-blue-lighter-toeic text-white p-2 text-base">Prosody<br>韻律</div>
                    <div class="text-2xl font-bold bg-gray-toeic2 p-3 text-black">70</div>
                  </div>
                </div>
              </div>
              <div class="chart-wrapper mx-auto" style="width: 300px; max-width: 100%;">
                <div id="radarChartContainer" class="my-4"></div>
              </div>
            </div>
          `,
          didOpen: () => {
            // 動態建立 radarChart 元件
            const RadarChartClass = Vue.extend(radarChart)
            const instance = new RadarChartClass({
              propsData: {
                // 可以傳你的分數進去
                accuracy: 60,
                fluency: 80,
                completeness: 50,
                prosody: 70
              }
            })
            instance.$mount('#radarChartContainer')
          },
          showConfirmButton: false,
          showCloseButton: true,
          focusConfirm: false,
          title: '回答分析',
          customClass: {
            title: 'text-white bg-blue-lighter-toeic text-2xl pb-3',
            container: '',
            popup: 'p-0 max-w-3xl w-100',
            header: 'position-relative',
            closeButton: 'closeButton position-absolute',
            htmlContainer: 'my-3',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            cancelButton: 'bg-red-main-ai',
          }
        })
      },
      audio_play () {
        if (!this.sound_effect) return
        // this.isPlayingAudio = true
        this.sound_effect.play()
        // this.sound_effect.playbackRate = this.playbackRate
        this.sound_effect.addEventListener('ended', () => {
          this.audio_stop()
        })
      },
      audio_stop () {
        // this.isPlayingAudio = false
        this.sound_effect.pause()
        this.sound_effect.currentTime = 0
      },
      getData () {
        let path = `/assessments/records/${this.$route.params.record_id}`

        api.get(path)
        .then((res) => {
          this.reportData = res.data
          console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
      },
      getQuestionAnalysisData () {
        let path = `https://api.liveabc.com/v1/livelibrary/Question/7d4fe169-6809-4449-9a4f-aa6312027bd4?showAnswer=true&showExplain=true`

        api.get(path)
        .then((res) => {
          this.questionAnalysis = res.data.data
          console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
      },
      emitSelectedIndex (payload) {
        this.selectedIndex = payload.index
        this.selectedIndex2 = payload.qIndex
      },
      showExplanation () {
        this.$swal({
          title: '<h4 class="text-white mb-3">解析說明</h4>',
          html: `
            <div class="text-left swal-content-wrapper" style="font-size:16px; line-height:1.6;">
              <p>口說測驗部分，另外針對考生在發音（Pronunciation）及語調與重音（Intonation and Stress）兩方面的表現分別給予評分（分高、中、低三級），並含其他能力敘述。</p>

              <!-- 發音等級 -->
              <table class="table table-bordered mt-3 text-center symmetric-table">
                <thead class="text-white" style="background-color:#a578d2;">
                  <tr>
                    <th>發音等級（Pronunciation）</th>
                    <th>說明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>低 Low</td><td>朗讀時，發音不容易理解。</td></tr>
                  <tr><td>中 Medium</td><td>朗讀時，發音普通可以理解，但有時還是會有錯誤。</td></tr>
                  <tr><td>高 High</td><td>朗讀時，發音非常容易可以理解。</td></tr>
                </tbody>
              </table>

              <!-- 語調與重音等級 -->
              <table class="table table-bordered mt-3 text-center symmetric-table">
                <thead class="text-white" style="background-color:#a578d2;">
                  <tr>
                    <th>語調與重音等級（Intonation and Stress）</th>
                    <th>說明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>低 Low</td><td>朗讀時，語調與重音的使用不是很適當。</td></tr>
                  <tr><td>中 Medium</td><td>朗讀時，語調與重音的使用大致還算適當。</td></tr>
                  <tr><td>高 High</td><td>朗讀時，語調與重音的使用非常適當。</td></tr>
                </tbody>
              </table>
            </div>
          `,
          width: 800,
          background: '#0074b7',
          showConfirmButton: false,
          showCloseButton: true,
          customClass: {
            htmlContainer: 'm-0 p-0', // ✅ 移除 swal 預設左右 padding
            popup: 'rounded-lg shadow-lg p-0 position-relative bg-white max-w-4xl w-100',
            content: 'p-4',
            closeButton: 'text-white closeButton',
            title: '',
            header: 'bg-blue-lighter-toeic pb-2'
          }
        })
      },
      showQuestion () {
        // const iconPlay = require(this.questionAnalysis?.ImageUrl) || ''
          // <div>
          //   <img src="${iconPlay}" alt="" class="object-contain w-100">
          // </div>
        this.$swal({
          title: '<h4 class="text-white mb-0 py-2">題目</h4>',
          html: `
          <div>
            <div class="text-left d-flex align-items-center whitespace-nowrap" style="font-size:16px; line-height:1.6;">
              <p class="text-blue-main-toeic font-weight-bold mb-2 mr-2">Directions</p>
              <audio id="userAudio" controls class="w-100 bg-white rounded mb-3 toeic-audio"></audio>
            </div>
            <p class="text-left">${this.returnReportData?.result?.question?.Description}</p>
          </div>
          <div>
            <div class="text-left d-flex align-items-center whitespace-nowrap" style="font-size:16px; line-height:1.6;">
              <p class="text-blue-main-toeic font-weight-bold mb-2 mr-2">參考答案</p>
              <audio id="userAudio2" controls class="w-100 bg-white rounded mb-3 toeic-audio"></audio>
            </div>
            <p class="text-left">${this.questionAnalysis?.Answer}</p>
          </div>
          `,
          width: 800,
          background: '#0074b7',
          showConfirmButton: false,
          showCloseButton: true,
          customClass: {
            htmlContainer: 'm-0 p-0', // ✅ 移除 swal 預設左右 padding
            popup: 'rounded-lg shadow-lg p-0 position-relative bg-white max-w-4xl w-100',
            content: 'p-4',
            closeButton: 'text-white closeButton',
            title: '',
            header: 'bg-blue-lighter-toeic pb-2'
          },
          didOpen: () => {
            // ✅ 這裡插入音檔連結
            const audio = document.getElementById('userAudio')
            const audio2 = document.getElementById('userAudio2')
            if (audio && this.returnReportData?.result?.question) {
              audio.src = this.returnReportData.result.question.AudioUrl
              audio2.src = this.questionAnalysis.AudioUrl
            }
          }
        })
      }
      // spiltWords (text) {
      //   let words = text.split(/(\s+|[,.!?])/).filter(Boolean)
      //   return words
      // },

      // checkScore (WordScores, text, child) {
      //   let parts = text.split(/(\s+|[,.!?])/).filter(Boolean)

      //   let wordsOnly = parts.filter(part => !part.match(/(\s+|[,.!?])/))

      //   let index = wordsOnly.indexOf(child)
      //   return Number(WordScores[index])
      // }
    }
  }
</script>
<style lang="scss" scoped>
.report_detailed {
  .report_detailed_inner {
    min-height: 160vh;
  }
  a {
    &:hover {
      text-decoration: none !important;
    }
  }
  .bg-gray-toeic {
    background-color: #C0C0C0;
  }
  .bg-gray-toeic2 {
    background-color: rgba(240, 240, 240, 1);
  }

  audio::-webkit-media-controls-panel {
    background-color: #ffffff !important;
  }
  .swal2-popup {
    color: #333;
  }
  .table th, .table td {
    vertical-align: middle !important;
  }
}
  .closeButton {
    position: absolute;
    top: 5px;
    right: 0;
  }
.swal2-html-container {
  padding: 0 !important;
  margin: 0 auto !important;
  width: 90%;
}

/* 讓表格左右完全對稱、欄位等寬 */
.symmetric-table {
  table-layout: fixed;
  width: 100%;
  background-color: #f9f3ff;
}
.symmetric-table th,
.symmetric-table td {
  vertical-align: middle;
  text-align: center;
  padding: 12px;
  border-color: #ddd;
}
.toeic-audio::-webkit-media-controls-panel {
    background-color: #ffffff !important;
  }
</style>
